<template>
  <div class="body-wrapper">

    <navigation-header/>

    <div class="layout-about">

      <div class="layout-banner">

        <div class="spacer left-with-color"></div>
        <div class="container">
          <div class="tabs">
            <a class="tab" href="/about">公司简介</a>
            <a class="tab active" href="/about/teacher">师资团队</a>
          </div>
        </div>
        <div class="spacer"></div>

      </div>

      <div class="teachers">

        <div class="container">

          <!--
          <div class="layout-section-title">
            <div class="section-title">{{section.title}}</div>
          </div>
          -->
          <div :id="teacher._id" class="teacher" v-for="teacher of teachers">
            <div class="photo" :style="{'background-image': getStyleUrl(teacher.photoUrl)}"></div>
            <div class="info" :class="{highlighted: teacher.isSuperior}">
              <div class="head">
                <div class="name">{{teacher.name}}</div>
                <div class="job-title">
                  <i v-if="teacher.isSuperior" class="icon icon-20 icon-medal"></i><span class="text">{{teacher.jobTitle}}</span>
                </div>
              </div>
              <div class="desc" v-html="getTeacherDescription(teacher)"></div>
            </div>
          </div>

        </div>

      </div>

    </div>

    <navigation-footer/>

  </div>
</template>

<script type="text/babel">
  'use strict';

  export default {
    computed: {
      teachers() {
        return window.preload.data.teachers;
      }
    },
    methods: {
      getStyleUrl(url) {
        return `url('${url}')`;
      },
      getTeacherDescription(teacher) {
        return this.$utils.formatParagragh(teacher.description);
      }
    }
  };
</script>


// WEBPACK FOOTER //
// client/app/vue-components/about-teacher/App.vue